import React from "react";
import ServiceHeroSection from "./service_hero";
import Products from "./product";
import ImageGrid from "../../components/company_grid";
import Footer from "../../components/footer";

function Service() {
  return (
    <div>
      <ServiceHeroSection />
      <Products />
      <ImageGrid />
      <Footer />
    </div>
  );
}

export default Service;
